// Whole-word "sound cards" for the Basic track. Each card focuses on a full
// CVC/CVCe word with a picture; learner taps to hear the whole word.
export const WORD_SOUND_CARDS = [
  { id: "ws-cat", word: "Cat", emoji: "🐱" },
  { id: "ws-dog", word: "Dog", emoji: "🐶" },
  { id: "ws-sun", word: "Sun", emoji: "☀️" },
  { id: "ws-hat", word: "Hat", emoji: "🎩" },
  { id: "ws-pig", word: "Pig", emoji: "🐷" },
  { id: "ws-cup", word: "Cup", emoji: "☕" },
  { id: "ws-fox", word: "Fox", emoji: "🦊" },
  { id: "ws-bus", word: "Bus", emoji: "🚌" },
  { id: "ws-bee", word: "Bee", emoji: "🐝" },
  { id: "ws-moon", word: "Moon", emoji: "🌙" },
  { id: "ws-cake", word: "Cake", emoji: "🎂" },
  { id: "ws-fish", word: "Fish", emoji: "🐟" },
  { id: "ws-star", word: "Star", emoji: "⭐" },
  { id: "ws-tree", word: "Tree", emoji: "🌳" },
  { id: "ws-book", word: "Book", emoji: "📖" },
  { id: "ws-frog", word: "Frog", emoji: "🐸" },
];
